import ApiService from "@/core/services/ApiService"
import JwtService from "@/core/services/JwtService"
import { Actions, Mutations } from "@/store/enums/StoreEnums"
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators"
import { AxiosRequestConfig } from "axios"
import { BoxType } from "@/store/modules/BoxInfoModule"

export interface Product {
  sku: string
  name: string
  image: string
  image_url: string
  price: number
  recycle_price: number
  link: string
  brand_id: number
  product_brand_id?: number
  ip_id: number
  is_presale: boolean
  arrival_date: Date
  stock: number
  is_on_sale: boolean
  is_point: boolean
  note?: string
  is_bundle_gift: boolean
  is_card: boolean
  auto_open: boolean
  need_shipping_fee: boolean
  product_images_attributes: Array<any>
  product_gifts_attributes: Array<ProductGift>
  recycle_type: string
  product_type: string
  pool_type?: string
  is_recyclable: boolean
  is_composable: boolean
  allow_to_deliver: boolean
  event_id?: number | string | null
  event_point?: number
  reward_min?: number
  reward_max?: number
  // 商城相关字段
  is_mall_product?: boolean
  is_arrived?: boolean
  presale_payment_mode?: string  // full_only, deposit_only, deposit_or_full
  deposit_type?: string          // fixed, percent
  deposit_amount?: number
  deposit_percent?: number
  mall_stock?: number
  purchase_limit?: number
  water_need?: number
  daily_purchase_limit?: number
}
export interface ProductGift {
  gift_product_id: number,
  product: string,
  brand: string,
  price: number,
  recycle_price: number,
  quantity: number,
  sorting: number,
  _destroy?: number
}

export interface ProductInfo {
  products: Array<Product>
  all_products: Array<Product>
  product: Product
}

export interface ProductBrandOption {
  key: string,
  value: string
}

export interface ProductIpOption {
  key: string,
  value: string
}

export interface ProductOption {
  key: string,
  value: string
}

@Module
export default class ProductModule
  extends VuexModule
  implements ProductInfo
{
  products = [] as Array<Product>
  all_products = [] as Array<Product>
  product_count = 0
  product = {} as Product
  product_brand_options = [] as Array<ProductOption>
  product_ip_options = [] as Array<ProductOption>
  product_recycle_type_options = [] as Array<ProductOption>
  download_products = {} as any
  box_products = [] as Array<BoxType>
  eat_products = [] as Array<BoxType>
  cook_products = [] as Array<BoxType>
  relative_box_infos = [] as any

  get currentProduct(): Product {
    return this.product
  }

  get currentProducts(): Array<Product> {
    return this.products
  }

  get currentAllProducts(): Array<Product> {
    return this.all_products
  }

  get currentProductBrandOptions(): Array<ProductOption> {
    return this.product_brand_options
  }

  get currentProductIpOptions(): Array<ProductOption> {
    return this.product_ip_options
  }

  get currentProductRecycleTypeOptions(): Array<ProductOption> {
    return this.product_recycle_type_options
  }

  get currentProductCount() {
    return this.product_count
  }

  get currentDownloadProducts(){
    return this.download_products
  }

  get currentBoxProducts(){
    return this.box_products
  }

  get currentEatProducts(){
    return this.eat_products
  }

  get currentCookProducts(){
    return this.cook_products
  }

  get currentRelativeBoxInfos(){
    return this.relative_box_infos
  }

  // get getErrors() {
  //   return this.errors;
  // }

  @Mutation
  [Mutations.SET_PRODUCT](product) {
    this.product = product
  }

  @Mutation
  [Mutations.SET_PRODUCTS](products) {
    this.products = products
  }

  @Mutation
  [Mutations.SET_ALL_PRODUCTS](all_products) {
    this.all_products = all_products
  }

  @Mutation
  [Mutations.SET_DOWNLOAD_PRODUCTS](download_products) {
    this.download_products = download_products
  }

  @Mutation
  [Mutations.SET_PRODUCT_BRAND_OPTIONS](product_brand_options) {
    this.product_brand_options = product_brand_options
  }

  @Mutation
  [Mutations.SET_PRODUCT_IP_OPTIONS](product_ip_options) {
    this.product_ip_options = product_ip_options
  }

  @Mutation
  [Mutations.SET_PRODUCT_RECYCLE_TYPE_OPTIONS](product_recycle_type_options) {
    this.product_recycle_type_options = product_recycle_type_options
  }

  @Mutation
  [Mutations.SET_PRODUCT_COUNT](product_count) {
    this.product_count = product_count
  }

  @Mutation
  [Mutations.SET_BOX_PRODUCTS](payload) {
    this.box_products = payload.box_products
    this.eat_products = payload.eat_products || []
    this.cook_products = payload.cook_products || []
  }

  @Mutation
  [Mutations.SET_RELATIVE_BOX_INFOS](relative_box_infos) {
    this.relative_box_infos = relative_box_infos
  }

  @Action
  [Actions.GET_PRODUCTS](params) {
    ApiService.setHeader()

    let queryString = "?"

    if (params) {
      Object.keys(params).forEach((i) => {
        queryString += "&" + i + "=" + params[i];
      });
    }

    return new Promise<void>((resolve, reject) => {
      ApiService.get("admin/products", queryString)
        .then(({ data }) => {
          console.log(data["products"])
          this.context.commit(
            Mutations.SET_PRODUCTS,
            data["products"]
          );
          this.context.commit(
            Mutations.SET_PRODUCT_COUNT,
            data["total_result"]
          );
          resolve();
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.SET_ERROR, response.data.errors)
          reject();
        });
    });
  }

  @Action
  [Actions.GET_ALL_PRODUCTS](params) {
    ApiService.setHeader()

    let queryString = "?"

    if (params) {
      Object.keys(params).forEach((i) => {
        queryString += "&" + i + "=" + params[i];
      });
    }

    return new Promise<void>((resolve, reject) => {
      ApiService.get("admin/products/all", queryString)
        .then(({ data }) => {
          console.log(data["products"])
          this.context.commit(
            Mutations.SET_ALL_PRODUCTS,
            data["products"]
          )
          resolve();
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.SET_ERROR, response.data.errors)
          reject();
        });
    });
  }

  @Action
  [Actions.GET_PRODUCT_BRAND_OPTIONS](params) {
    ApiService.setHeader()

    let queryString = "?"

    if (params) {
      Object.keys(params).forEach((i) => {
        queryString += "&" + i + "=" + params[i];
      });
    }

    return new Promise<void>((resolve, reject) => {
      ApiService.get("admin/products/get_product_brand_options", queryString)
        .then(({ data }) => {
          this.context.commit(
            Mutations.SET_PRODUCT_BRAND_OPTIONS,
            data["product_brand_options"]
          )
          resolve();
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.SET_ERROR, response.data.errors)
          reject();
        });
    });
  }

  @Action
  [Actions.GET_PRODUCT_IP_OPTIONS](params) {
    ApiService.setHeader()

    let queryString = "?"

    if (params) {
      Object.keys(params).forEach((i) => {
        queryString += "&" + i + "=" + params[i];
      });
    }

    return new Promise<void>((resolve, reject) => {
      ApiService.get("admin/products/get_product_ip_options", queryString)
        .then(({ data }) => {
          this.context.commit(
            Mutations.SET_PRODUCT_IP_OPTIONS,
            data["product_ip_options"]
          )
          resolve();
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.SET_ERROR, response.data.errors)
          reject();
        });
    });
  }

  @Action
  [Actions.GET_PRODUCT_RECYCLE_TYPE_OPTIONS](params) {
    ApiService.setHeader()

    let queryString = "?"

    if (params) {
      Object.keys(params).forEach((i) => {
        queryString += "&" + i + "=" + params[i];
      });
    }

    return new Promise<void>((resolve, reject) => {
      ApiService.get("admin/products/get_product_recycle_type_options", queryString)
        .then(({ data }) => {
          this.context.commit(
            Mutations.SET_PRODUCT_RECYCLE_TYPE_OPTIONS,
            data["product_recycle_type_options"]
          )
          resolve();
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.SET_ERROR, response.data.errors)
          reject();
        });
    });
  }

  @Action
  [Actions.GET_PRODUCT](id) {
    ApiService.setHeader();

    return new Promise<void>((resolve, reject) => {
      ApiService.get(`admin/products/${id}`)
        .then(({ data }) => {
          console.log(data["product"]);
          this.context.commit(
            Mutations.SET_PRODUCT,
            data["product"]
          );
          resolve();
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.SET_ERROR, response.data.errors)
          reject();
        });
    });
  }

  @Action
  [Actions.GET_DOWNLOAD_PRODUCTS](params) {
    ApiService.setHeader()

    let queryString = "?"

    if (params) {
      Object.keys(params).forEach((i) => {
        queryString += "&" + i + "=" + params[i]
      })
    }

    return new Promise<void>((resolve, reject) => {
      ApiService.get("admin/products/download_excel", queryString, {responseType: 'blob'})
        .then(({ data }) => {
          this.context.commit(
            Mutations.SET_DOWNLOAD_PRODUCTS,
            data
          )
          resolve()
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.SET_ERROR, response.data.errors)
          reject()
        })
    })
  }

  @Action
  [Actions.CREATE_PRODUCT](credentials) {
    ApiService.setHeader()

    const params = {
      product: {
        ...credentials,
      },
    };

    return new Promise<void>((resolve, reject) => {
      ApiService.post(`admin/products`, params)
        .then(({ data }) => {
          const success = (data && data.result && data.result.success) || data?.success === true
          if (success) {
            if (data && data["product"]) {
              this.context.commit(
                Mutations.SET_PRODUCT,
                data["product"]
              );
            }
            resolve();
          } else {
            const errorMsg = data?.result?.error_msg || data?.error_msg || '新增失败'
            this.context.commit(Mutations.SET_ERROR, errorMsg)
            reject();
          }
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.SET_ERROR, response?.data?.errors || '请求失败')
          reject();
        });
    });
  }

  @Action
  [Actions.UPDATE_PRODUCT](credentials) {
    ApiService.setHeader()

    const params = {
      product: {
        ...credentials.values,
      },
    };

    return new Promise<void>((resolve, reject) => {
      ApiService.put(`admin/products/${credentials.id}`, params)
        .then(({ data }) => {
          const success = (data && data.result && data.result.success) || data?.success === true
          if (success) {
            if (data && data["product"]) {
              this.context.commit(
                Mutations.SET_PRODUCT,
                data["product"]
              );
            }
            resolve();
          } else {
            const errorMsg = data?.result?.error_msg || data?.error_msg || '更新失败'
            this.context.commit(Mutations.SET_ERROR, errorMsg)
            reject();
          }
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.SET_ERROR, response?.data?.errors || '请求失败');
          reject();
        });
    });
  }

  @Action
  [Actions.UPLOAD_PRODUCTS](params) {
    ApiService.setHeader()

    const formData = new FormData()
    const file = params['file']
    formData.append('file', file)

    return new Promise<void>((resolve, reject) => {
      ApiService.post_multipart(`admin/products/upload`, formData)
        .then(({ data }) => {
          // this.context.commit(
          //   Mutations.SET_PRODUCT,
          //   data["product"]
          // );
          resolve();
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.SET_ERROR, response.data.errors);
          reject();
        });
    });
  }

  @Action
  [Actions.DELETE_PRODUCT](id) {
    ApiService.setHeader()

    return new Promise<void>((resolve, reject) => {
      ApiService.delete(`admin/products/${id}`)
        .then(({ data }) => {
          resolve()
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.SET_ERROR, response.data.errors)
          reject()
        })
    })
  }

  @Action
  [Actions.ABANDON_PRODUCT](id) {
    ApiService.setHeader()

    return new Promise<void>((resolve, reject) => {
      ApiService.put(`admin/products/${id}/abandon`, {})
        .then(({ data }) => {
          resolve()
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.SET_ERROR, response.data.errors)
          reject()
        })
    })
  }

  @Action
  [Actions.GET_BOX_PRODUCTS](params) {
    ApiService.setHeader()

    return new Promise<void>((resolve, reject) => {
      ApiService.get("admin/products/box_products")
        .then(({ data }) => {
          this.context.commit(
            Mutations.SET_BOX_PRODUCTS,
            {
              box_products: data["box_products"],
              eat_products: data["eat_products"],
              cook_products: data["cook_products"]
            }
          )

          resolve()
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.SET_ERROR, response.data.errors)
          reject()
        })
    })
  }

  @Action
  [Actions.GET_RELATIVE_BOX_INFOS](id) {
    ApiService.setHeader()

    return new Promise<void>((resolve, reject) => {
      ApiService.get(`admin/products/${id}/relative_box_infos`)
        .then(({ data }) => {
          this.context.commit(
            Mutations.SET_RELATIVE_BOX_INFOS,
            data["box_infos"]
          );
          resolve();
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.SET_ERROR, response.data.errors)
          reject();
        });
    });
  }

  @Action
  [Actions.UPLOAD_PRODUCT_IMAGES](formData: FormData) {
    ApiService.setHeader();
    return new Promise<any>((resolve, reject) => {
      ApiService.post_multipart('admin/products/upload_images', formData)
        .then(({ data }) => resolve(data))
        .catch(({ response }) => reject(response?.data));
    });
  }

  @Action
  [Actions.GET_PRODUCT_IMAGES_UPLOAD_STATUS](jobId: string) {
    ApiService.setHeader();
    return new Promise<any>((resolve, reject) => {
      ApiService.get('admin/products/upload_images_status', `?job_id=${jobId}`)
        .then(({ data }) => resolve(data))
        .catch(({ response }) => reject(response?.data));
    });
  }
}
